import fetchModel from "../../models/fetchModel";
import apiErrorModel from "../../models/apiErrorModel";
import Loading from "../Loading/Loading";
import React, {useEffect, useState} from "react";

import './_AdmitToggle.scss';

const AdmitToggle = ({ ticketId, admitted, callback, userRole }) => {
  let [isLoading, setIsLoading] = useState(false);
  let [mutableAdmitted, setMutableAdmitted] = useState(admitted);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    setMutableAdmitted(admitted)
  },[admitted])

  function toggleAdmitted(e) {
    setIsLoading(true);
    const newAdmitted = !mutableAdmitted;

    const responseCallback = (response) => {
      setIsLoading(false);

      if (apiErrorModel.hasError(response)) {
        setLoadError(response.error);
        return;
      }

      setLoadError(null);
      if (response.admitted === true) {
        setMutableAdmitted(true);
      } else if (response.admitted === false) {
        setMutableAdmitted(false);
      }
      callback(response.admitted);
    };

    let url = userRole === 'staff' ? '/staff/ticket/admission' : '/ticket/admission';
    const fetchFunction = userRole === 'staff' ? fetchModel.postStaff : fetchModel.post;

    fetchFunction(
      url,
      { ticketId, admitted: newAdmitted },
      responseCallback
    );
  }

  function errorMessages() {
    if (isLoading || !loadError) {
      return null;
    }

    return (
      <div className="AdmitToggle-error">
        {apiErrorModel.getDisplayMessage(loadError)}
      </div>
    );
  }

  function loadingOrNot() {
    return (
      <>
        <label 
          className={`AdmitToggle-label ${mutableAdmitted ? 'isAdmitted' : ''}`}
          data-testid="admit-toggle"
          onClick={() => toggleAdmitted()}
        >
          {isLoading ? <Loading /> : null}
          <input
            className="AdmitToggle-checkbox"
            type="checkbox"
            // checked={mutableAdmitted}
            onChange={toggleAdmitted}
          />
          <span className="AdmitToggle-text">{mutableAdmitted ? 'Guest Admitted' : 'Admit Guest'}</span>
        </label>
      </>
    )
  }
  
  return <div className="AdmitToggle">
    {loadingOrNot()}
    {errorMessages()}
  </div>;
};

export default AdmitToggle;
